import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import analytics from "~/services/analytics";
import { ON_AIR_VIEWER_PAGE, ON_AIR_STATUS } from "./constants";
import Watch from "./scenes/Watch";
import PreScreen from "./scenes/PreScreen";
import EmbedPreScreen from "./scenes/EmbedPreScreen";
import EmbedWatch from "./scenes/EmbedWatch";
import { Layout } from "./styles";
var _obj;
var ON_AIR_DISPLAY = (_obj = {}, _define_property(_obj, ON_AIR_VIEWER_PAGE.EMBED_PRESCREEN, EmbedPreScreen), _define_property(_obj, ON_AIR_VIEWER_PAGE.EMBED_WATCH, EmbedWatch), _define_property(_obj, ON_AIR_VIEWER_PAGE.PRESCREEN, PreScreen), _define_property(_obj, ON_AIR_VIEWER_PAGE.WATCH, Watch), _obj);
var _obj1;
var DISPLAY_EVENT = (_obj1 = {}, _define_property(_obj1, ON_AIR_VIEWER_PAGE.EMBED_PRESCREEN, analytics.events.ON_AIR_WEBINAR_EMBED_PRESCREEN_PAGE_VISITED), _define_property(_obj1, ON_AIR_VIEWER_PAGE.PRESCREEN, analytics.events.ON_AIR_WEBINAR_PRE_SCREEN_PAGE_VISITED), _define_property(_obj1, ON_AIR_VIEWER_PAGE.EMBED_WATCH, analytics.events.ON_AIR_WEBINAR_EMBED_WATCH_PAGE_VISITED), _define_property(_obj1, ON_AIR_VIEWER_PAGE.WATCH, analytics.events.ON_AIR_WEBINAR_WATCH_PAGE_VISITED), _obj1);
var OnAirPageDisplay = function(param) {
    var page = param.page, webinar = param.webinar;
    var DisplayComponent = ON_AIR_DISPLAY[page];
    var isRegistrationEnabled = webinar.isRegistrationEnabled, isUserRegistered = webinar.isUserRegistered, status = webinar.status;
    useEffect(function() {
        if (!DISPLAY_EVENT[page]) {
            return;
        }
        analytics.track(DISPLAY_EVENT[page], {
            isRegistrationEnabled: isRegistrationEnabled,
            isUserRegistered: isUserRegistered,
            status: status
        });
    }, [
        isRegistrationEnabled,
        isUserRegistered,
        page,
        status
    ]);
    useEffect(function() {
        if (!isRegistrationEnabled && status === ON_AIR_STATUS.CREATED) {
            analytics.track(analytics.events.ON_AIR_WEBINAR_REGISTRATION_OFF_PAGE_VISITED);
        }
    }, [
        isRegistrationEnabled,
        status
    ]);
    if (page === ON_AIR_VIEWER_PAGE.WATCH) {
        return /*#__PURE__*/ _jsx(DisplayComponent, {});
    }
    return /*#__PURE__*/ _jsx(Layout, {
        children: /*#__PURE__*/ _jsx(DisplayComponent, {})
    });
};
export default OnAirPageDisplay;
